import { RESULT, UID } from 'shared/api/query/constants';
import {
  accessPolicy,
  propertyValue,
  updateTemplate,
  user,
} from 'shared/api/query/configs.json';
import {
  accessPolicyChildren,
  propertyValueEdges,
  userEdgesSlim,
} from 'shared/api/query/edges';
import { accessPolicyType } from 'shared/constants.json';

export const children = [
  { attr: UID },
  { attr: updateTemplate.edges.title },
  { attr: updateTemplate.edges.icon },
  { attr: updateTemplate.edges.template, default: null },
  { attr: updateTemplate.edges.accessRight, default: accessPolicyType.read },
  {
    attr: updateTemplate.edges.propertyValues,
    default: [],
    model: propertyValue.model,
    children: propertyValueEdges,
  },
  {
    attr: updateTemplate.edges.creator,
    model: user.model,
    children: userEdgesSlim,
    default: null,
  },
  {
    attr: updateTemplate.edges.accessPolicy,
    model: accessPolicy.model,
    default: null,
    children: accessPolicyChildren,
  },
];

export const updateTemplateById = (id) => [{
  alias: RESULT,
  func: { name: 'uid', uid: [id] },
  model: updateTemplate.model,
  children,
}];

export const updateTemplateList = () => [{
  alias: RESULT,
  func: { name: 'type', args: [{ value: updateTemplate.model }] },
  model: updateTemplate.model,
  children,
}];
